module.exports = __webpack_public_path__ + "static/img/banner_science.d9238ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_science.png
// module id = cWxc
// module chunks = 15